import { Form, Input, Radio, Select } from 'antd';
import { Rule } from 'antd/lib/form';
import InputPercent from 'components/lib/formFields/InputPercent';
import { FC, useEffect, useState } from 'react';
import { RDVM_DISCOUNT_TYPE, RDVM_PRIORITY, RDVM_RELATIONSHIP_STATUS } from 'utils/consts';
import { Hospital } from 'utils/types';
import { validateFieldIsGreaterThan } from 'utils/validationFuncs';

interface RelationshipTabPaneProps {
    hospitals: Hospital[];
    userHasPrimaryLocationEditPermission: boolean;
    initialDiscountType?: string;
    form?: any;
}

const RelationshipTabPane: FC<RelationshipTabPaneProps> = ({
    hospitals,
    userHasPrimaryLocationEditPermission,
    initialDiscountType,
    form,
}) => {
    const [discountType, setDiscountType] = useState(initialDiscountType || null);

    let discountAmountInput;
    let discountRules: Rule[] = [];

    if (discountType === 'Percentage') {
        discountAmountInput = <InputPercent />;
    } else if (discountType === 'Fixed amount') {
        discountAmountInput = <Input type='number' min={0} />;
        discountRules = [
            {
                validator: validateFieldIsGreaterThan('Duration', 0),
            },
        ];
    } else if (discountType === 'Other') {
        discountAmountInput = <Input type='text' />;
    } else {
        discountAmountInput = <Input disabled />;
    }

    useEffect(() => {
        if (initialDiscountType !== discountType) {
            form.setFieldsValue({ discount_amount: null });
        }
    }, [discountType, initialDiscountType, form]);

    return (
        <>
            <Form.Item name='associated_hospital_id' label='Primary VEG:'>
                <Select
                    allowClear={true}
                    placeholder='Select a VEG hospital'
                    disabled={!userHasPrimaryLocationEditPermission}
                    options={hospitals?.map((hosp) => ({
                        value: hosp.id,
                        label: hosp.display_name,
                    }))}
                />
            </Form.Item>
            <Form.Item name='discount_type' label='Discount Type:'>
                <Select placeholder='Select discount type' onChange={(value) => setDiscountType(value)}>
                    {RDVM_DISCOUNT_TYPE.map((discount) => (
                        <Select.Option key={discount.value} value={discount.value}>
                            {discount.name}
                        </Select.Option>
                    ))}
                </Select>
            </Form.Item>
            <Form.Item name='discount_amount' label={discountType === 'Other' ? 'Discount:' : 'Discount Amount:'} rules={discountRules}>
                {discountAmountInput}
            </Form.Item>
            <Form.Item name='has_call_forwarding' label='Has Call Forwarding:'>
                <Radio.Group>
                    <Radio value='true'>Yes</Radio>
                    <Radio value='false'>No</Radio>
                </Radio.Group>
            </Form.Item>
            <Form.Item name='relationship_status' label='Relationship Status:'>
                <Select placeholder='Select relationship status'>
                    {RDVM_RELATIONSHIP_STATUS.map((status) => (
                        <Select.Option key={status.value} value={status.value}>
                            {status.name}
                        </Select.Option>
                    ))}
                </Select>
            </Form.Item>
            <Form.Item name='priority' label='Priority:'>
                <Select placeholder='Select priority'>
                    {RDVM_PRIORITY.map((priority) => (
                        <Select.Option key={priority.value} value={priority.value}>
                            {priority.name}
                        </Select.Option>
                    ))}
                </Select>
            </Form.Item>
        </>
    );
};

export default RelationshipTabPane;
